import React from 'react';
import { FormSelect } from 'components/form';
import { Box, IconButton, Stack } from '@mui/material';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';
import { Home, Restore, List, Remove, Add, Timeline } from '@mui/icons-material';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { StagesList } from './StagesList';
import { StagesManagerViewProps } from './types';
import { StagesSkeleton } from './StagesSkeleton';
import { StyledContainer } from './StyledContainer';
import { StagesContainer } from './StagesContainer';
import { StagesTimeline } from '../stagesTimeline';

export const StagesWidget = ({ onSwitchToLegacyStages, ...otherProps }: StagesManagerViewProps) => (
  <StagesContainer {...otherProps}>
    {({
      stages,
      loading,
      actions,
      templates,
      stagesView,
      timelineView,
      activeTemplate,
      stagesViewType,
      activeDepartmentId,
      departmentsOptions,
    }) => (
      <StyledContainer>
        <RenderWithCondition
          condition={timelineView === 'off'}
          fallBack={
            <StagesTimeline
              parentId={otherProps.parentId}
              activeTemplateId={activeTemplate}
              parentType={otherProps.parentType}
              onBackToStages={actions.onSwitchTimeline}
              parentCreatedAt={otherProps.parentCreatedAt}
            />
          }
        >
          <RenderWithFallback isLoading={loading.genericLoading} fallBack={<StagesSkeleton />}>
            <Box className="stagesWidgetHeader">
              <Stack direction="row" gap="0.5rem">
                {timelineView === 'off' && (
                  <IconButton
                    size="small"
                    color="primary"
                    className="icon-btn-bordered"
                    onClick={actions.onSwitchTimeline}
                  >
                    <Timeline />
                  </IconButton>
                )}

                <IconButton
                  size="small"
                  color="primary"
                  className="icon-btn-bordered"
                  onClick={actions.onChangeViewType}
                >
                  {stagesViewType === 'all' ? <Remove /> : <Add />}
                </IconButton>
              </Stack>

              <StagesList
                loading={loading}
                onViewStage={actions.onViewStage}
                viewedStage={stages.viewedStageId}
                activeStage={stages.activeStageId!}
                stages={templates[activeTemplate!]?.stages ?? []}
              />

              <Box className="stagesWidgetHeaderActions">
                <FormSelect
                  variant="outlined"
                  sx={{ width: '12rem' }}
                  label="Business Process"
                  value={activeDepartmentId}
                  options={departmentsOptions}
                  onValueChange={actions.onChangeDepartment}
                />

                <ActionsMenu
                  config={[
                    {
                      label: 'Legacy Stages',
                      action: onSwitchToLegacyStages,
                      icon: <Restore color="primary" />,
                    },
                    {
                      action: actions.onChangeViewType,
                      label: stagesViewType === 'active' ? 'View all stages ' : 'Default View',
                      icon: stagesViewType === 'active' ? <List color="primary" /> : <Home color="primary" />,
                    },
                  ]}
                />
              </Box>
            </Box>

            {stagesView}
          </RenderWithFallback>
        </RenderWithCondition>
      </StyledContainer>
    )}
  </StagesContainer>
);
